import { useMemo } from 'react';
import { GEO_COOKIE_NAME } from '@/lib/geo';

export function useIsEU(): boolean {
  return useMemo(() => {
    if (typeof document === 'undefined') return false;
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${GEO_COOKIE_NAME}=([^;]*)`));
    return match?.[1] === '1';
  }, []);
}
